import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormInputParam } from '../form-input-params';
import { FormFieldEmitParams } from '../params/form-field-emit-params';
import { SmartyAddressService } from './smarty-address.service';



@Component({
  selector: 'lib-address-autocomplete',
  templateUrl: './address-autocomplete.component.html',
  styleUrls: ['./address-autocomplete.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class AddressAutocompleteComponent implements OnInit {
  @Output() selectedPlace: EventEmitter<any> = new EventEmitter();
   @Output() Blur: EventEmitter<boolean> = new EventEmitter();
  @Input() params: FormInputParam;
   @Input()
  zipCode!: string;

  @Input()
  state!: string;
  @Output() fieldValue: EventEmitter<FormFieldEmitParams> = new EventEmitter();
  Object = Object;

  /**
   * Variable declared to handle focus scenario in ADA
   */
  enableFocusRing = false;
  lastBlurInputValue: string;
  placeSelected = false;
  filteredOptions: any[] = [];
  private typingTimer: any;


  constructor(private addressService:SmartyAddressService) {
  }
  
  getAddressSuggestions(id: string) {
    clearTimeout(this.typingTimer);
    this.filteredOptions = [];
    const value = this.params.formGroup.get(this.params.formControllName).value;
    this.placeSelected = false;
    if (value && value.length >= 3) {
      this.typingTimer = setTimeout(() => {
        this.addressService.getAddressSuggestions(value, this.zipCode, this.state).subscribe((suggestions) => {
          this.filteredOptions = suggestions;

        });
      }, 300);
    }
  }
  focusHandle() {
    this.enableFocusRing = true;
    this.placeSelected = false;
  } 
  blurHandle() {
    setTimeout(() => { 
      this.enableFocusRing = false;
      /**
       * US255602: Segment Field level tracking
       */
      const inputTextValue = this.params.formGroup.get(this.params.formControllName).value;
      if(!this.placeSelected){
         this.Blur.emit(true);
      };
      if (inputTextValue && inputTextValue.length > 0 && inputTextValue !== this.lastBlurInputValue && !this.placeSelected) {
        this.lastBlurInputValue = inputTextValue;
        this.fieldValue.emit({ value: inputTextValue, event: 'Value Added' });
      };
    }, 300);
  }

  ngOnInit() {

  }
  onPlaceSelect( event: any ) {
     const address = this.filteredOptions.find(option => option.full_address === event?.option?.value);
    if (address) {
      this.filteredOptions = [];
      this.selectedPlace.emit(address);
      this.Blur.emit(true);
    this.placeSelected = true;
    }
    
  }
  getErrorMessage(messages, key, value) {
    return messages[key].replace(/{}/g, value);
  }

}